export default {
  state: {
    MenuList: null,
    PermissionList: null
  },
  getters: {
    MenuList: state => {
      return state.MenuList
    },
    PermissionList: state => {
      return state.PermissionList
    }
  },
  mutations: {
    setMenuList: (state, menuList) => {
      state.MenuList = menuList
    },
    setPermissionList: (state, permissionList) => {
      state.PermissionList = permissionList
    }
  },
  actions: {}
}
